import { Component, Input, OnInit } from '@angular/core';
import { ModalComponent } from '../../../../../core/config/core.modal-helpers';

@Component({
  selector: 'tracker-extra-field-delete',
  template: require('./tracker.extra.field.delete.modal.component.html')
})
export class TrackerExtraFieldDeleteComponent extends ModalComponent implements OnInit {
  @Input() field: any;

  fieldAliasToDelete: string;

  /**
   * Initializes the component, setting up the alias of the field to be deleted.
   */
  ngOnInit() {
    this.fieldAliasToDelete = this.field.alias;
  }

  /**
   * Deletes the field and closes the modal.
   */
  delete() {
    this.closeModal(this.field);
  }

  /**
   * Cancels the deletion and closes the modal.
   */
  cancel() {
    this.closeModal();
  }
}
